import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRubricCache } from './cache'
import {
  type RecordingRubricUpdateInput,
  type RecordingRubricUpdateSuccess,
  type RubricData,
  toResponseError,
} from '@terros/common'

export function useUpdateRubric(): UpdateHookResponse<RecordingRubricUpdateInput['rubric'], RubricData> {
  const mutation = useTantalimMutation<RecordingRubricUpdateInput, RecordingRubricUpdateSuccess>({
    url: '/recording/rubric/update',
  })
  const cache = useRubricCache()

  async function update(rubric: RecordingRubricUpdateInput['rubric']): Promise<RubricData> {
    try {
      const { rubric: updatedRubric } = await mutation.mutateAsync({ rubric })
      cache.clearItem(rubric.rubricId)
      cache.clearList()
      return updatedRubric
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
